import { render, staticRenderFns } from "./StatementTable.vue?vue&type=template&id=d937e9d0&scoped=true&"
import script from "./StatementTable.vue?vue&type=script&lang=js&"
export * from "./StatementTable.vue?vue&type=script&lang=js&"
import style0 from "./StatementTable.vue?vue&type=style&index=0&id=d937e9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d937e9d0",
  null
  
)

export default component.exports